'use strict';

const { h } = require('phy');

module.exports = option => {
  const { promoIneligible } = option || {};

  if (!promoIneligible) {
    return null;
  }

  return h('.promo-ineligible', promoIneligible.text);
};
